module.exports = __webpack_public_path__ + "static/media/text_dan_walsh.fb2c38ed.svg";